var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "statistics",
    opacity: 0.5,
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    fill: "#3f90e3",
    d: "M5.64,17.81A3.29,3.29,0,0,0,8,16.87l3.3,1.65c0,.14,0,.27,0,.4a3.34,3.34,0,1,0,6.68,0,3.26,3.26,0,0,0-.33-1.43L22,13a3.29,3.29,0,0,0,4.6-4l3.88-2.91a3.34,3.34,0,1,0-.93-4.63A3.3,3.3,0,0,0,29,3.34a3.32,3.32,0,0,0,.17,1L25.3,7.24a3.32,3.32,0,0,0-4.85,4.21L16,15.92a3.31,3.31,0,0,0-3.75.6l-3.3-1.65a1.75,1.75,0,0,0,0-.4,3.34,3.34,0,1,0-3.34,3.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    fill: "#3f90e3",
    d: "M36.89,35.77H35.7V12.25a1.12,1.12,0,0,0-1.11-1.12H30.13A1.12,1.12,0,0,0,29,12.25h0V35.77H26.79V18.93a1.11,1.11,0,0,0-1.11-1.12H21.23a1.12,1.12,0,0,0-1.12,1.12h0V35.77H17.89V27.83a1.12,1.12,0,0,0-1.12-1.11H12.32a1.11,1.11,0,0,0-1.11,1.11h0v7.94H9V23.38a1.11,1.11,0,0,0-1.11-1.11H3.41A1.11,1.11,0,0,0,2.3,23.38h0V35.77H1.11a1.12,1.12,0,0,0,0,2.23H36.89a1.12,1.12,0,0,0,0-2.23Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphBlue);
export default __webpack_public_path__ + "static/media/GraphBlue.f5afb7a2eae02055932c8d106a74d124.svg";
export { ForwardRef as ReactComponent };